<template>
  <div class="card-banner">
    <div class="header">
      <img class="logo" src="@/assets/zs_imgs/ck-header-logo.png" alt="抽抽乐" />
      <span class="title">抽抽乐</span>
      <div class="record" @click="$emit('record')">
        <div class="icon"></div>
        <div class="txt">抽抽乐记录</div>
      </div>
    </div>
    <div class="main">
      <div class="nav">
        <div
          v-for="nav in navList"
          class="nav-item"
          :key="nav.id"
          :style="{ 'background-image': `url(${nav.thumb_image})` }"
          @click="handleChangeCurrentNav(nav)"
        >
          <span class="time">{{ formatDay(nav.end_at) }}</span>
          <div v-if="currentNav.id !== nav.id" class="mask"></div>
        </div>
      </div>
      <div class="content">
        <img v-if="currentNav.image" class="role-image" :src="currentNav.image" :alt="currentNav.name" />
        <div class="bg-img">
          <div class="inner-content">
            <div class="title-line"></div>
            <div class="pickup">{{ currentNav.role_name }}</div>
            <div class="name">{{ currentNav.name }}</div>
            <div class="star">
              <template v-if="currentNav.star">
                <img
                  v-for="index in parseInt(currentNav.star)"
                  :key="index"
                  class="icon"
                  src="@/assets/zs_imgs/ck-banner-star.png"
                  alt="星"
                />
              </template>
            </div>
            <div class="desc">
              <div class="icon-box">
                <img class="sup" src="@/assets/zs_imgs/ck-role-border-sup.png" />
                <!-- <img class="icon" :src="currentNav.icon" :alt="currentNav.name" /> -->
                <div class="icon" :style="{ backgroundImage: `url(${currentNav.icon})` }"></div>
                <div class="up">up</div>
              </div>
              <div class="txt">
                活动期间（~{{ formatEndTime(currentNav.end_at) }}前），{{ currentNav.role_name
                }}{{ currentNav.name }}服装获得率增加
              </div>
            </div>
            <div style="margin-top: 24px;">
              <RateCount :num="maxNum" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "@/plugins/dayjs";

import RateCount from "./RateCount";
import AssetCount from "./AssetCount";

export default {
  name: "CardBanner",
  components: { RateCount, AssetCount },
  props: {
    navList: {
      type: Array,
      default: () => []
    },
    maxNum: {
      type: Number,
      default: 0
    },
    currentNav: { type: Object, default: () => ({}) },
    assetCount: { type: Number, default: 0 }
  },

  methods: {
    handleChangeCurrentNav(nav) {
      this.$emit("currentNavChange", nav);
    },
    formatDay(value) {
      const d = dayjs().diff(dayjs(value * 1000), "day");
      return `D-${d}`;
    },
    formatEndTime(value) {
      return dayjs(value * 1000).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
<style lang="less" scoped>
.card-banner {
  height: 100%;
  transform: translateZ(1px);
  background-color: rgba(0, 0, 0, 0.1);
  .header {
    position: absolute;
    top: 22px;
    right: 43px;
    left: 126px;
    height: 38px;
    display: flex;
    align-items: center;
    z-index: 2;
    .logo {
      width: 20px;
      height: 22px;
    }
    .title {
      color: #fff;
      font-size: 17px;
      font-weight: 500;
      margin-left: 4px;
    }
    .record {
      height: 22px;
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 0 4px;
      border-radius: 12px;
      background-color: rgba(0, 0, 0, 0.5);
      margin-left: 10px;
      cursor: pointer;
      .icon {
        width: 14px;
        height: 14px;
        background: url("~@/assets/zs_imgs/ck-record-icon.png") center no-repeat;
        background-size: 8px 8px;
        background-color: rgb(223, 218, 213);
        border-radius: 50%;
        padding: 2px;
      }
      .txt {
        color: rgb(223, 218, 213);
        font-size: 12px;
      }
    }
  }
  .main {
    height: 100%;
    display: flex;
    padding: 0 62px 100px 90px;
    gap: 12px;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.2) 9.164%,
        rgba(0, 0, 0, 0) 16.048%,
        rgba(0, 0, 0, 0) 84.321%,
        rgba(0, 0, 0, 0.16) 88.925%
      ),
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0.89) 14.443%,
        rgba(0, 0, 0, 0) 27.068%,
        rgba(0, 0, 0, 0) 95.038%,
        rgba(0, 0, 0, 0.6) 100%
      );
    .nav {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding-top: 112px;
      .nav-item {
        position: relative;
        width: 108px;
        height: 58px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        .time {
          font-size: 11px;
          color: #fff;
          margin: 2px;
        }
        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 1;
          background-color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    .content {
      flex-grow: 1;
      position: relative;
      overflow: hidden;
      .role-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 270px;
        height: 150%;
        z-index: 1;
        object-fit: cover;
        object-position: center top;
      }
      .bg-img {
        position: absolute;
        bottom: 0;
        width: 606px;
        height: 268px;
        background: url("https://cdnimg-v2.gamekee.com/wiki2.0/images/w_1120/h_480/50118/418239/2025/2/13/73016.png")
          no-repeat center / cover;
        .inner-content {
          position: absolute;
          height: 100%;
          width: 328px;
          top: 0;
          right: 0;
          display: flex;
          flex-direction: column;
          .title-line {
            width: 15px;
            height: 2px;
            background: rgb(185, 188, 233);
            margin-top: 20px;
          }
          .pickup {
            font-size: 13px;
            color: rgb(192, 196, 246);
            margin-top: 8px;
          }
          .name {
            background: linear-gradient(to bottom, rgb(233, 221, 225), rgb(208, 93, 164));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            font-size: 34px;
            font-weight: 700;
            line-height: 49px;
          }
          .star {
            display: flex;
            align-items: center;
            position: relative;
            &::after {
              content: "";
              position: absolute;
              width: 100%;
              top: 50%;
              transform: translateY(-50%);
              height: 1px;
              background-color: #b9bce9;
            }
            .icon {
              // width: 16px;
              // height: 16px;
            }
          }
          .desc {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            margin-top: 20px;
            .icon-box {
              position: relative;
              width: 64px;
              height: 64px;
              background: url("~@/assets/zs_imgs/ck-color-border.png") 100% 100% no-repeat;
              .icon {
                width: 56px;
                height: 56px;
                margin: 4px;
                background-color: #3c372c;
                background-position: top center;
              }
              .sup {
                position: absolute;
                width: 20px;
                height: 20px;
                top: -5px;
                left: -5px;
              }
              .up {
                position: absolute;
                width: 18px;
                height: 21px;
                line-height: 14px;
                top: -2px;
                right: -2px;
                background: url("~@/assets/zs_imgs/ck-color-border-up.png") center no-repeat;
                background-size: contain;
                font-size: 12px;
                color: #fff8cf;
                text-align: center;
              }
            }
            .txt {
              flex-grow: 1;
              width: 0;
              color: #fff;
              font-size: 12px;
              line-height: 17px;
            }
          }
        }
      }
    }
  }
}
</style>
